var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-coupon-table',{staticClass:"pt-coupon-table__withData",attrs:{"table-data":_vm.tableData,"total-number":_vm.totalNumber,"audit-status":_vm.auditStatus,"loading":_vm.loading},on:{"couponList":_vm.couponList}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }